// extracted by mini-css-extract-plugin
export default {"recommendations":"eB","retake_quiz":"fB","products":"gB","unsure":"hB","icons":"iB","icon":"jB"};
    if(module.hot) {
      // 1711717533339
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  